module.exports = __webpack_public_path__ + "img/duoxuan.5d47d936.png";